import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';
import { withRouter } from 'react-router-dom';
import PopupAlert from '../../components/PopupAlert';
import logo from '../../newLogo.svg';
import { Button } from '../../components';
import { apiEditProject } from '../../api/projects';
import './EditProject.scss';
import infoIcon from '../../assets/images/infoIcon.svg';
import { v4 as genUniqId } from 'uuid';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import FontAwesomeIconPicker from '../CreateProject/FontPicker/FontAwesomeIconPicker';
import { faTrash, faPlus } from '@fortawesome/free-solid-svg-icons'
import OutsideClickHandler from 'react-outside-click-handler/build/OutsideClickHandler';
import { SketchPicker } from 'react-color';

function EditProject(props) {
  const history = useHistory();

  const project = props.location.state.project;
  console.log(project, "prjectData");

  const [projectName, setProjectName] = useState(
    project.labels[0].name_display
  );
  const [experienceOneText, setExperienceOneText] = useState(
    project.experience_1_text
  );
  const [experienceOneLink, setExperienceOneLink] = useState(
    project.experience_1_link
  );
  const [experienceTwoText, setExperienceTwoText] = useState(
    project.experience_2_text
  );
  const [experienceTwoLink, setExperienceTwoLink] = useState(
    project.experience_2_link
  );
  const alertRef = React.createRef();

  const [description, setDescription] = useState(project.description);
  const [encryptions, setEncryptions] = useState(project.labels[0].encryptions);
  const [material, setMaterial] = useState(project.labels[0].material);
  const [printType, setPrintType] = useState(project.labels[0].print_type);
  const [editScreenObj, setEditScreenObj] = useState({ price: "", style: "", features_title: "", add_features: "", features: [] })
  const [editedTabsFields, setEditedTabsFields] = useState([{ id: genUniqId(), text: '', icon: "", url: "", }]);
  const [editButtonfields, setEditButtonFields] = useState([{ id: genUniqId(), text: '', color: "", url: "", openColorPicker: false }]);

  const onEditInput = () => {
    const editedFields = [...editButtonfields, { id: genUniqId(), text: '', color: '', url: '' }];
    setEditButtonFields(editedFields);
  };
  const onEditTabsInput = () => {
    const editedTabs = [...editedTabsFields, { id: genUniqId(), text: '', icon: '', url: '' }];
    setEditedTabsFields(editedTabs);
  };
  const handleEditButtonsChange = (id, name, value) => {
    const editedButtons = editButtonfields.map(btn =>
      btn.id === id ? { ...btn, [name]: value } : btn
    );
    setEditButtonFields(editedButtons);
  };
  const handleEditTabsChange = (editObjId, name, value) => {
    const editedTabs = editedTabsFields.map(tabs =>
      tabs.id === editObjId ? { ...tabs, [name]: value } : tabs
    );
    setEditedTabsFields(editedTabs);
  };
  const handleDeleteEditedRows = (type, id) => {
    if (type === "edit_buttons") {
      const editedFields = editButtonfields.filter((btnField) => btnField?.id !== id);
      setEditButtonFields(editedFields);

    } else if (type === "edit_icons") {
      const editedFields = editedTabsFields.filter((tabField) => tabField?.id !== id);
      setEditedTabsFields(editedFields);

    }
  }
  const closePicker = () => {
    let editedFields = editButtonfields.map((el) => (
      { ...el, openColorPicker: false }
    ))
    setEditButtonFields(editedFields)
  }

  const openColorPicker = (id) => {
    let editedFields = editButtonfields.map((btn) => {
      if (btn?.id === id) {
        return { ...btn, openColorPicker: !btn?.openColorPicker }
      }
      return btn
    })
    setEditButtonFields(editedFields)
  }
  const removeRepeaterInputs = (type, id) => {
    let filteredItems = editScreenObj?.[type]?.filter((el) => el?.id !== id)
    setEditScreenObj((prevState) => {
      let obj = { ...prevState, [type]: filteredItems }
      return obj
    })
  }

  const handleEditSucces = (event, fieldName) => {
    let value = event.target.value
    setEditScreenObj((prevState) => {
      let obj = { ...prevState, [fieldName]: value }
      return obj
    })
  }
  const handleEditRepeaterInputs = (type) => {
    let value = editScreenObj?.add_features
    if (value.length >= 1) {
      let uniqId = genUniqId()
      let newObj = { id: uniqId, label: value }
      let latestFeatures = [...editScreenObj?.[type], newObj]
      setEditScreenObj((prevState) => {
        let obj = { ...prevState, add_features: "", [type]: latestFeatures }
        return obj
      })

    }

  }
  const handleEnterKeyPress = (event, type) => {
    if (event.key === 'Enter') {
      handleEditRepeaterInputs()
    }
  };
  const goToDashboard = () => {
    // history.push('/dashboard/live');
    
    history.goBack()
  };

  const success = (vals) => {
    alertRef.current.show({
      message: 'Project edited successfully',
      callback: goToDashboard,
    });
  };

  const failure = (e) => {
    console.log(e);

    alertRef.current.show({
      message: 'API error',
    });
  };
  const getEdittedScreenObj = () => {
    let newButtonsArray = editButtonfields?.map((el) => {
      delete el["openColorPicker"]
      delete el["id"]
      return el
    })
    let newTabsArray = editedTabsFields?.map((el) => {
      delete el["id"]
      return el
    })
    let newFeaturesArray = editScreenObj?.features?.map((el) => el?.label)
    let success_parameters = { ...editScreenObj, features: newFeaturesArray, buttons: newButtonsArray, tabs: newTabsArray }
    delete success_parameters["add_features"]
    return success_parameters
  }
  const edit = (e) => {
    const success_parameters = getEdittedScreenObj()
    const data = {
      success_parameters,
      projectId: project.id,
      projectName,
      projectUrl: project.project_url,
      experienceOneText,
      experienceOneLink,
      experienceTwoText,
      experienceTwoLink,
      description,
      encryptions,
      material,
      printType,
    };

    apiEditProject(data, project.labels[0].id, success, failure);
  };

  const cancel = (e) => {
    history.push('/dashboard/live');
  };
  console.log(editedTabsFields, "EditedTabsFields")
  // const [editedTabsFields, setEditedTabsFields] = useState([{ id: genUniqId(), text: '', icon: "", url: "", }]);
  // const [editButtonfields, setEditButtonFields] = useState([{ id: genUniqId(), text: '', color: "", url: "", openColorPicker: false }]);
  useEffect(() => {
    if (project?.success_parameters && Object.keys(project?.success_parameters?.length >= 1)) {
      let newObj = project?.success_parameters
      let newfeaturesArr = newObj?.features?.map((el) => ({ id: genUniqId(), label: el }))
      let newButtonsArr = newObj?.buttons?.map((el) => ({ id: genUniqId(), openColorPicker: false, ...el }))
      let newTabsArr = newObj?.tabs?.map((el) => ({ id: genUniqId(), ...el }))
      let editObj = { price: newObj?.price ? newObj?.price : "", style: newObj?.style ? newObj?.style : "", features_title: newObj?.features_title ? newObj?.features_title : "", add_features: "", features: newObj?.features ? newfeaturesArr : [] }
      setEditButtonFields(newButtonsArr?.length ? newButtonsArr : [{ id: genUniqId(), text: '', color: "", url: "", openColorPicker: false }])
      setEditedTabsFields(newTabsArr?.length >= 1 ? newTabsArr : [{ id: genUniqId(), text: '', icon: "", url: "", }])
      setEditScreenObj(editObj)
    }

  }, [project])
  console.log(editScreenObj, "ediiiiit")
  return (
    <div>
      <Container fluid>
        <Row className="color-div">
          <Col xs={12} sm={12} md={12} lg={12} xl={12} className="bg-white">
            <div className="Register-form">
                <Row>
                  <Col md={12} lg={12}>
                    <div className="logo">
                      <img src={logo} alt="logo" />
                    </div>
                    <div className="form">
                      <div className="Heading">
                        <p className="heading-1">Edit Project</p>
                      </div>

                      <Row>
                        <Col md={12} lg={12}>
                          <div className="form-floating">
                            <label htmlFor="projectName">Project Name</label>
                            <img src={infoIcon} alt="info" />
                            <input
                              type="text"
                              className="form-control"
                              id="projectName"
                              value={projectName}
                              onChange={(e) => setProjectName(e.target.value)}
                              placeholder="Project Name"
                            />
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col md={6} lg={6}>
                          <div className="form-floating">
                            <label htmlFor="projectName">
                              Experience One - Text
                            </label>
                            <img src={infoIcon} alt="info" />
                            <input
                              type="text"
                              className="form-control"
                              id="experienceOneText"
                              value={experienceOneText}
                              onChange={(e) =>
                                setExperienceOneText(e.target.value)
                              }
                              placeholder="Text"
                            />
                          </div>
                        </Col>
                        <Col md={6} lg={6}>
                          <div className="form-floating">
                            <label htmlFor="projectName">URL</label>
                            <img src={infoIcon} alt="info" />
                            <input
                              type="text"
                              className="form-control"
                              id="experienceOneLink"
                              value={experienceOneLink}
                              onChange={(e) =>
                                setExperienceOneLink(e.target.value)
                              }
                              placeholder="URL"
                            />
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col md={6} lg={6}>
                          <div className="form-floating">
                            <label htmlFor="projectName">
                              Experience Two - Text
                            </label>
                            <img src={infoIcon} alt="info" />
                            <input
                              type="text"
                              className="form-control"
                              id="experienceTwoText"
                              value={experienceTwoText}
                              onChange={(e) =>
                                setExperienceTwoText(e.target.value)
                              }
                              placeholder="Text"
                            />
                          </div>
                        </Col>
                        <Col md={6} lg={6}>
                          <div className="form-floating">
                            <label htmlFor="projectName">URL</label>
                            <img src={infoIcon} alt="info" />
                            <input
                              type="text"
                              className="form-control"
                              id="experienceTwoLink"
                              value={experienceTwoLink}
                              onChange={(e) =>
                                setExperienceTwoLink(e.target.value)
                              }
                              placeholder="URL"
                            />
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col md={12} lg={12}>
                          <div className="area-floating">
                            <label htmlFor="projectName">Description</label>
                            <img src={infoIcon} alt="info" />
                            <textarea
                              type="text"
                              rows={6}
                              className="form-control"
                              id="description"
                              value={description}
                              onChange={(e) => setDescription(e.target.value)}
                              placeholder="Project Description"
                            />
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col md={6} lg={6}>
                          <div className="form-floating">
                            <label htmlFor="projectName">Material</label>
                            <img src={infoIcon} alt="info" />
                            <select
                              type="text"
                              className="form-control"
                              id="material"
                              value={material}
                              onChange={(e) => setMaterial(e.target.value)}
                            >
                              <option value="">Select</option>
                              <option value="Paper">Paper</option>
                              <option value="Fabric">Fabric</option>
                            </select>
                          </div>
                        </Col>
                        <Col md={6} lg={6}>
                          <div className="form-floating">
                            <label htmlFor="projectName">Print Type</label>
                            <img src={infoIcon} alt="info" />
                            <select
                              type="text"
                              className="form-control"
                              id="printType"
                              value={printType}
                              onChange={(e) => setPrintType(e.target.value)}
                            >
                              <option value="">Select</option>
                              <option value="Lithography">Lithography</option>
                              <option value="Digital">Digital</option>
                              <option value="Coated">Coated</option>
                            </select>
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col md={6} lg={6}>
                          <div className="form-floating">
                            <label htmlFor="projectName">
                              Number of Encryptions
                            </label>
                            <img src={infoIcon} alt="info" />
                            <input
                              type="text"
                              className="form-control"
                              id="encryptions"
                              value={encryptions}
                              onChange={(e) => setEncryptions(e.target.value)}
                              placeholder="1"
                            />
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Row>

                          <Row>
                            <Col md={6} lg={6}>
                              <div className="form-floating">
                                <label htmlFor="price">Price</label>
                                <img src={infoIcon} alt="info" />
                                <input
                                  type="text"
                                  className="form-control"
                                  id="price"
                                  value={editScreenObj?.price}
                                  onChange={(e) => handleEditSucces(e, "price")}
                                  placeholder="Ex. 20"
                                />
                              </div>
                            </Col>
                            <Col md={6} lg={6}>
                              <div className="form-floating">
                                <label htmlFor="style">Style</label>
                                <img src={infoIcon} alt="info" />
                                <input
                                  type="text"
                                  className="form-control"
                                  id="style"
                                  value={editScreenObj?.style}
                                  onChange={(e) => handleEditSucces(e, "style")}
                                  placeholder="Ex. Lorem ipsum"

                                />
                              </div>

                            </Col>
                          </Row>
                          <Row>
                            <Col md={6} lg={6}>
                              <div className="form-floating">
                                <label htmlFor="features_title">Features Title</label>
                                <img src={infoIcon} alt="info" />
                                <input
                                  type="text"
                                  className="form-control"
                                  id="features_title"
                                  value={editScreenObj?.features_title}
                                  onChange={(e) => handleEditSucces(e, "features_title")}
                                  placeholder="Ex. Lorem ipsum"
                                />
                              </div>


                            </Col>

                          </Row>
                          <Col md={6} lg={6} >
                            <div className="form-floating ">
                              <label htmlFor="add_features">Edit Features</label>
                              <img src={infoIcon} alt="info" />
                              <div className='custom-container'>
                                <input
                                  type="text"
                                  className="form-control"
                                  id="add_features"
                                  value={editScreenObj?.add_features}
                                  onChange={(e) => handleEditSucces(e, "add_features")}
                                  placeholder="Ex. Lorem ipsum"
                                  onKeyDown={handleEnterKeyPress}
                                />
                                <div className='common-btn add-features-btn' onClick={() => handleEditRepeaterInputs("features")}><FontAwesomeIcon icon={faPlus} /></div>

                              </div>

                            </div>
                          </Col>

                        </Row>

                        {editScreenObj?.features.length >= 1 ? (
                          <Row>
                            <Col md={6} lg={6} >
                              <div className="list-container">
                                {editScreenObj?.features.map((el) => (
                                  <div key={el?.id} className='list-items-container'>
                                    <div className='list-label'>{el?.label}</div>
                                    <div className='btn btn-xl btn-danger cancel-btn' onClick={() => removeRepeaterInputs("features", el?.id)}> <FontAwesomeIcon icon={faTrash} />
                                    </div>
                                  </div>
                                ))}

                              </div>

                            </Col>

                          </Row>
                        ) : null}
                        <div className='dynamic-input-container'>
                          <Row>
                            <Col md={6} lg={6}>
                              <div className="form-floating label-container">
                                <label >Edit Buttons</label>
                                <img src={infoIcon} alt="info" />
                              </div>
                            </Col>
                          </Row>
                          {editButtonfields.map((field, index) => (
                            <Row key={index} className='input-fields-container'>
                              <Col md={4} lg={4} >
                                <div className={index >= 1 ? "form-floating" : "form-floating custom-first-btn-field"}>
                                  <label htmlFor={`field${field.id}`}>Button Title</label>
                                  <img src={infoIcon} alt="info" />
                                  <input
                                    name={`text${field.id}`}
                                    id={`text${field.id}`}
                                    value={field.text}
                                    type="text"
                                    className="form-control"
                                    onChange={(e) => handleEditButtonsChange(field.id, "text", e.target.value)}
                                    placeholder="Ex. Lorem ipsum"
                                  />

                                </div>
                              </Col>

                              <Col md={4} lg={4} >
                                <div className={index >= 1 ? "form-floating" : "form-floating custom-first-btn-field"}>
                                  <label htmlFor={`field${field.id}`}>Url</label>
                                  <img src={infoIcon} alt="info" />
                                  <div className='custom-container'>
                                    <input
                                      name={`url${field.id}`}
                                      id={`url${field.id}`}
                                      value={field.url}
                                      type="text"
                                      className="form-control"
                                      onChange={(e) => handleEditButtonsChange(field.id, "url", e.target.value)}
                                      placeholder="Ex. https://www.stegvision.com/"
                                    />
                                  </div>

                                </div>
                              </Col>
                              <Col md={4} lg={4} >
                                <div className={index >= 1 ? "form-floating" : "form-floating custom-first-btn-field"}>
                                  <label htmlFor={`color${field.id}`}>Color</label>
                                  <img src={infoIcon} alt="info" />
                                  <div className='picker-container'>

                                    <div className='color-picker-container'>
                                      <div className='selection-container'>

                                        <label >{field?.color && field?.color}</label>
                                        <button className='common-btn' type="button" onClick={() => openColorPicker(field?.id)}>Edit Color
                                        </button>
                                        {index >= 1 && (

                                            <div className='delete-edit-content'>
                                              <div className='btn btn-xl btn-danger cancel-btn' onClick={() => handleDeleteEditedRows("edit_buttons", field?.id)}> <FontAwesomeIcon icon={faTrash} /></div>
                                            </div>
                                        )}

                                      </div>

                                      {field?.openColorPicker && (
                                        <OutsideClickHandler onOutsideClick={closePicker}>
                                          <SketchPicker className="sketch-color-picker" color={"#fffff"} onChange={(newColor) => handleEditButtonsChange(field?.id, "color", newColor.hex)} />
                                        </OutsideClickHandler>
                                      )}

                                    </div>

                                  </div>


                                </div>
                              </Col>

                            </Row>
                          ))}
                          <button className='common-btn' type="button" onClick={onEditInput}>
                            <FontAwesomeIcon icon={faPlus} />
                          </button>

                        </div>
                        <Col md={12} lg={12}>
                          <div className='dynamic-input-container'>
                            <Row>
                              <Col md={6} lg={6}>
                                <div className="form-floating">
                                  <label >Edit Tabs</label>
                                  <img src={infoIcon} alt="info" />
                                </div>
                              </Col>
                            </Row>
                            {editedTabsFields.map((field, index) => (
                              <Row key={index} className='input-fields-container'>
                                <Col md={4} lg={4} >
                                  <div className={index >= 1 ? "form-floating" : "form-floating custom-first-btn-field"}>
                                    <label htmlFor={`field${field.id}`}>Tab Title</label>
                                    <img src={infoIcon} alt="info" />
                                    <input
                                      name={`text${field.id}`}
                                      id={`text${field.id}`}
                                      value={field.text}
                                      type="text"
                                      className="form-control"
                                      onChange={(e) => handleEditTabsChange(field.id, "text", e.target.value)}
                                      placeholder="Ex. Lorem ipsum"
                                    />

                                  </div>
                                </Col>

                                <Col md={4} lg={4} >
                                  <div className={index >= 1 ? "form-floating" : "form-floating custom-first-btn-field"}>
                                    <label htmlFor={`field${field.id}`}>Url</label>
                                    <img src={infoIcon} alt="info" />
                                    <div className='custom-container'>
                                      <input
                                        name={`url${field.id}`}
                                        id={`url${field.id}`}
                                        value={field.url}
                                        type="text"
                                        className="form-control"
                                        onChange={(e) => handleEditTabsChange(field.id, "url", e.target.value)}
                                        placeholder="Ex. https://www.stegvision.com/"
                                      />
                                    </div>

                                  </div>
                                </Col>
                                <Col md={4} lg={4} >
                                  <div className={index >= 1 ? "form-floating" : "form-floating custom-first-btn-field"}>
                                    <label htmlFor={`icon${field.id}`}>Icon</label>
                                    <img src={infoIcon} alt="info" />
                                    <div className='icons-container'>
                                      <FontAwesomeIconPicker value={field?.icon} isEdit={true} onChange={handleEditTabsChange} id={field.id} delComponent={index >= 1 && (
                                        <div className='btn btn-xl btn-danger cancel-btn' key={index} onClick={() => handleDeleteEditedRows("edi_icons", field?.id)}><FontAwesomeIcon icon={faTrash} /></div>
                                      )} />
                                      {index >= 1 && (
                                        <div className='delete-edit-content'>
                                          <div className='btn btn-xl btn-danger cancel-btn' key={index} onClick={() => handleDeleteEditedRows("edi_icons", field?.id)}><FontAwesomeIcon icon={faTrash} /></div>
                                        </div>
                                      )}

                                    </div>
                                  </div>
                                </Col>


                              </Row>
                            ))}
                            {editedTabsFields?.length <= 4 && (
                              <button className='common-btn' type="button" onClick={onEditTabsInput}>
                                <FontAwesomeIcon icon={faPlus} />
                              </button>
                            )}


                          </div>
                        </Col>
                      </Row>
                      <div className="btns-flex">
                        <Button name="Save Changes" onclick={edit} />
                        <Button name="Cancel" onclick={cancel} />
                      </div>
                    </div>
                  </Col>
                </Row>
            </div>
          </Col>
        </Row>
      </Container>
      <PopupAlert ref={alertRef} />
    </div>
  );
}

export default withRouter(EditProject);
